import { ongBaseApi } from "../../../api/ong-base-api";
import { clearLocalStorageAccessToken } from "../../../utils/local-storage/token";
import { clearSessionStorageAccessToken } from "../../../utils/session-storage/token";
import { ProfileState } from "../../type/profile-state";

export const logoutDispatch = (state: ProfileState) => {
  clearSessionStorageAccessToken();
  clearLocalStorageAccessToken();
  delete ongBaseApi.defaults.headers.common["Authorization"];
  state.isLoggedIn = false;
};
